import { createReducer, on } from '@ngrx/store';
import * as actions from './current-context-function.actions';

export const initialState = 0;

export const currentContextFunctionReducer = createReducer(
  initialState,
  on(actions.setCurrentContextFunction, (state, { functionHierarchyId }) => Number(functionHierarchyId)),
);
